import { EventCardModel } from '@apps/accountMe/routes/Me/Me.controller';
import { EventRedirectEventMembershipsQuery, EventUserStatus } from '@graphql/generated';
import { Location } from 'history';

export const getSubPath = (loc: Location) => {
  const subPath = loc.pathname.replace(/^\/event/, '');

  return subPath + loc.search;
};

// Taken from src/apps/accountMe/routes/Me/Me.controller.ts#L51
const sortEventUsers = (cards: Array<EventCardModel>) => {
  return cards.sort((userA, userB) => {
    if (userA.status === userB.status) {
      return userA.datems === userB.datems ? 0 : (userA.datems ?? 0) < (userB.datems ?? 0) ? 1 : -1;
    }
    if (userA.status === EventUserStatus['owner']) {
      return -1;
    }
    if (userB.status === EventUserStatus['owner']) {
      return 1;
    }
    if (userA.status === EventUserStatus['admin']) {
      return -1;
    }
    if (userB.status === EventUserStatus['admin']) {
      return 1;
    }
    return 1;
  });
};

type ActiveEventUser = NonNullable<EventRedirectEventMembershipsQuery['me']>['activeEventUsers'][number];

type ValidEventUser = {
  id: string;
  status: EventUserStatus.admin | EventUserStatus.owner;
  event: NonNullable<ActiveEventUser['event']>;
};

export const mapDataToEventCards = (data: Maybe<EventRedirectEventMembershipsQuery>, redirectSubPath: string) => {
  return sortEventUsers(
    data?.me?.activeEventUsers
      ?.filter(
        (eventUser): eventUser is ValidEventUser =>
          !!eventUser.event &&
          // Is an admin or owner
          (eventUser.status === 'admin' || eventUser.status === 'owner')
      )
      .map<EventCardModel>(({ status, event }) => {
        const statusLabel = status === 'owner' ? 'Owner' : 'Admin';
        return {
          id: event.info.id,
          postgresEventId: event.id,
          firebaseId: event.firebaseId,
          eventType: event.info.eventType,
          status: status,
          role: {
            status,
            label: statusLabel
          },
          roles: [statusLabel],
          name: event.info.eventDisplayName,
          dateString: event.info.finalizedDate?.dateString,
          datems: event.info.finalizedDate?.milliseconds,
          location: event.info.location,
          imageUrl: event.photo?.url,
          imageColor: event.style.primaryColorV0918.hex,
          eventLink: `/${event.website}${redirectSubPath}`,
          actions: []
        };
      }) || []
  );
};
